import axios from 'axios'

export default {
  options (code) {
    return axios.get('/gift-codes/' + encodeURIComponent(code) + '/options')
  },
  redeem (code, purchaseAmountCents, mealId) {
    return axios.post('/gift-codes/redeem', {
      code: code,
      purchase_amount_cents: purchaseAmountCents,
      meal_id: mealId
    })
  },
  redemptions (date, page) {
    return axios.get('/gift-codes/redemptions', { params: { date: date || undefined, page: page || undefined } })
  }
}
